<div class="content-wrapper flex flex-col h-screen w-screen overflow-hidden bg-white">
  <twaice-fe-toolbar data-intercom-target="dashboard-layout-toolbar" />

  <div class="flex w-full h-full flex-grow-default min-h-0">
    <twaice-fe-dashboard-sidenav
      class="flex flex-col justify-between h-full bg-white"
      data-intercom-target="dashboard-layout-sidenav"
    />

    <div class="router-content flex flex-1 flex-col w-full overflow-y-auto" [class.bg-white]="isHealth">
      <twaice-fe-navigation-menu
        *ngIf="showNavigationMenu"
        [isGlobal]="showGlobalNavigationMenu"
        [isFleet]="isFleet"
        [isPerformanceManagerSolution]="isPerformanceManagerSolution"
        [isWarrantyTracker]="isWarrantyTracker"
        [isDataExplorerSolution]="isDataExplorerSolution"
        [isPenaltyRiskSolution]="isPenaltyRiskSolution"
        [isAlertsSolution]="isAlertsSolution && !isRuleConfigurationPage"
        [isBMSAlertsSolution]="isBMSAlertsSolution && !isBMSConfigurationPage"
        data-intercom-target="dashboard-layout-navigation-menu"
      />
      <!-- Storage configuration keeps its own action bar pinned to the bottom of the viewport, so its
      pages must fit the space left under the navigation menu exactly (flex-1, not h-full — which
      would overflow by the menu's height and scroll that bar out of view). -->
      <div
        class="w-full overflow-y-auto"
        [class.h-full]="!isStorageConfiguration"
        [class.flex-1]="isStorageConfiguration"
        [class.min-h-0]="isStorageConfiguration"
        [class.p-32]="
          !isFleet &&
          !isPerformanceManagerSolution &&
          !isAssetDashboard &&
          !isSafetySolution &&
          !isWarrantyTracker &&
          !isReportsV2 &&
          !isProfessionalServices &&
          !isDataExplorerSolution &&
          !isHealth &&
          !isStorageHierarchy &&
          !isPenaltyRiskSolution &&
          !isAlertsSolution &&
          !isBMSAlertsSolution &&
          !isStorageOverviewSolution &&
          !isStorageConfiguration &&
          !isEventsSolution
        "
      >
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
